import { Box, Card, Icon, Link, Text } from '@nimbus-ds/components';
import { EditIcon } from '@nimbus-ds/icons';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface OurDomainCardProperties {
  ourDomain: string;
  onEdit: () => void;
}

type OurDomainCardProps = OurDomainCardProperties;

export function OurDomainCard({ ourDomain, onEdit }: OurDomainCardProps) {
  const t = useTranslationConfigurations('domains');

  return (
    <Card>
      <Card.Body>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap="16"
          onClick={onEdit}
          cursor="pointer"
        >
          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Text
              fontSize="caption"
              lineHeight="base"
              textAlign="left"
              color="neutral-textHigh"
            >
              {t('landing.subdomain_label')}
            </Text>
            <Text
              fontSize="caption"
              lineHeight="base"
              textAlign="left"
              color="neutral-textLow"
            >
              {ourDomain}
            </Text>
          </Box>
          <Link
            as="a"
            appearance="primary"
            textDecoration="none"
            onClick={onEdit}
          >
            {t('landing.edit_button')}
            <Icon color="primary-interactive" source={<EditIcon />} />
          </Link>
        </Box>
      </Card.Body>
    </Card>
  );
}
